// ABOUTME: Selects the WhatsApp pre-registration routing scope for one company.
// ABOUTME: Keeps Region data intact when another scope becomes active.
import React from "react";
import {
    Checkbox,
    FormControl,
    FormControlLabel,
    InputLabel,
    ListItemText,
    MenuItem,
    Paper,
    Radio,
    RadioGroup,
    Select,
    Typography
} from "@material-ui/core";

import { WhatsappPreRegistrationLabels } from "./whatsappPreRegistrationLabels";
import {
    WhatsappPreRegistrationConfig,
    WhatsappPreRegistrationOptions,
    WhatsappPreRegistrationRoutingMode
} from "./whatsappPreRegistrationSettingsModel";

interface WhatsappPreRegistrationRoutingEditorProps {
    config: WhatsappPreRegistrationConfig;
    stores: WhatsappPreRegistrationOptions["stores"];
    labels: WhatsappPreRegistrationLabels;
    onChange: (config: WhatsappPreRegistrationConfig) => void;
}

const getSelectValues = (value: unknown) =>
    (Array.isArray(value) ? value : String(value || "").split(","))
        .map((item) => String(item || "").trim())
        .filter(Boolean);

const getRoutingModeDescription = (
    routingMode: WhatsappPreRegistrationRoutingMode,
    labels: WhatsappPreRegistrationLabels
) => {
    if (routingMode === "COMPANY") {
        return labels.routingModeCompanyHelp;
    }
    if (routingMode === "BRANCH") {
        return labels.routingModeBranchHelp;
    }
    return labels.routingModeRegionBranchHelp;
};

const WhatsappPreRegistrationRoutingEditor = ({
    config,
    stores,
    labels,
    onChange
}: WhatsappPreRegistrationRoutingEditorProps) => (
    <Paper elevation={0} style={{ padding: 24 }}>
        <Typography variant="h6" gutterBottom>
            {labels.routingMode}
        </Typography>
        <RadioGroup
            value={config.routingMode}
            onChange={(event) =>
                onChange({
                    ...config,
                    routingMode: event.target
                        .value as WhatsappPreRegistrationRoutingMode
                })
            }
        >
            <FormControlLabel
                value="COMPANY"
                control={<Radio color="primary" />}
                label={labels.routingModeCompany}
            />
            <FormControlLabel
                value="BRANCH"
                control={<Radio color="primary" />}
                label={labels.routingModeBranch}
            />
            <FormControlLabel
                value="REGION_BRANCH"
                control={<Radio color="primary" />}
                label={labels.routingModeRegionBranch}
            />
        </RadioGroup>
        <Typography variant="body2" color="textSecondary">
            {getRoutingModeDescription(config.routingMode, labels)}
        </Typography>
        {config.routingMode === "BRANCH" && (
            <FormControl fullWidth variant="outlined" margin="normal">
                <InputLabel>{labels.branches}</InputLabel>
                <Select
                    multiple
                    value={config.branchIds}
                    onChange={(event) =>
                        onChange({
                            ...config,
                            branchIds: getSelectValues(event.target.value)
                        })
                    }
                    label={labels.branches}
                    renderValue={(selected) =>
                        getSelectValues(selected)
                            .map(
                                (branchId) =>
                                    stores.find(
                                        (store) => store.id === branchId
                                    )?.name || branchId
                            )
                            .join(", ")
                    }
                >
                    {stores.map((store) => (
                        <MenuItem key={store.id} value={store.id}>
                            <Checkbox
                                checked={config.branchIds.includes(store.id)}
                            />
                            <ListItemText
                                primary={`${store.name}${
                                    store.available === false
                                        ? ` (${labels.unavailable})`
                                        : ""
                                }`}
                            />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        )}
    </Paper>
);

export default WhatsappPreRegistrationRoutingEditor;
